import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Typography } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { getProductOrders } from "../../store/actions/productorder";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const OrdersPanel = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const order = useSelector((state) => state.productorder.list);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch all orders in a single request
        await dispatch(getProductOrders());
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  const ordersCounts = useMemo(() => {
    if (!order.length) return {};

    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const last7Days = new Date(now.setDate(now.getDate() - 7)).toISOString().split('T')[0];
    // const lastMonth = new Date(now.setMonth(now.getMonth() - 1)).toISOString().split('T')[0];
    const nowMoment = moment();
    const fromDate = nowMoment.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
    const toDate = nowMoment.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

    // Current quarter
    const fromDateThisQuarter = nowMoment.clone().startOf('quarter').format('YYYY-MM-DD');
    const toDateThisQuarter = nowMoment.clone().endOf('quarter').format('YYYY-MM-DD');

    // Current year
    const fromDateThisYear = nowMoment.clone().startOf('year').format('YYYY-MM-DD');
    const toDateThisYear = nowMoment.clone().endOf('year').format('YYYY-MM-DD');

    return {
      active: order.filter(c => c.status === 1).length,
      inactive: order.filter(c => c.status === 0).length,
      today: order.filter(c => c.status === 1 && c.createdAt.split('T')[0] === today).length,
      last7Days: order.filter(c => c.status === 1 && c.createdAt.split('T')[0] >= last7Days).length,
      lastMonth: order.filter(c => c.status === 1 && c.createdAt.split('T')[0] >= fromDate && c.createdAt.split('T')[0] <= toDate).length,
      lastQuarter: order.filter(c => c.status === 1 && c.createdAt.split('T')[0] >= fromDateThisQuarter && c.createdAt.split('T')[0] <= toDateThisQuarter).length,
      thisYear: order.filter(c => c.status === 1 && c.createdAt.split('T')[0] >= fromDateThisYear && c.createdAt.split('T')[0] <= toDateThisYear).length,
      total: order.length
    };
  }, [order]);

  const handleCardClick = (type) => {
    if (type === "today") {
      navigate('/prodorders/today'); 
    }
    if (type === "last7Days") {
      navigate('/prodorders/last7Days'); 
    }
    if (type === "lastMonth") {
      navigate('/prodorders/lastMonth'); 
    }
    if (type === "lastQuarter") {
      navigate('/prodorders/lastQuarter'); 
    }
    if (type === "thisYear") {
      navigate('/prodorders/thisYear'); 
    }
  };

  const renderCustomerCard = (title, count, type) => (
    <Col xl={4} sm={12}>
      <Card onClick={() => handleCardClick(type)}>
        <CardBody>
          <div className="d-flex text-muted">
            <div className="flex-shrink-0 me-3 align-self-center">
              <div className="avatar-sm">
                <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                  <i className="ri-group-line"></i>
                </div>
              </div>
            </div>
            <div className="flex-grow-1 overflow-hidden">
              <p className="mb-1">{title}</p>
              <h5 className="mb-3">{isLoading ? 'Loading...' : count}</h5>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );

  return (
    <React.Fragment>
      <Row>
        <Title level={5}>Orders</Title>
        {renderCustomerCard("Today's Orders", ordersCounts.today)}
        {renderCustomerCard("Last 7 Days Orders", ordersCounts.last7Days)}
        {renderCustomerCard("Last Month Orders", ordersCounts.lastMonth)}
        {renderCustomerCard("This Quarter Orders", ordersCounts.lastQuarter)}
        {renderCustomerCard("This Year Orders", ordersCounts.thisYear)}
        {renderCustomerCard("Total Orders", ordersCounts.total)}
      </Row>
    </React.Fragment>
  );
};

export default OrdersPanel;